const inventoryWidgetsList = [
  {
    id: "1",
    name: "Cars in Inventory",
    entity: "inventory",
    criteria: "carsInInventory",
    displayType: "count",
    icon: "RectangleStack",
    color: "#000000",
    navigationUrl: "/dashboard/inventory",
  },

  {
    id: "4",
    name: "Active Cars",
    entity: "inventory",
    criteria: "activeCars",
    displayType: "count",
    icon: "Signal",
    color: "#000000",
    navigationUrl: "/dashboard/inventory?tab=active",
  },
  {
    id: "5",
    name: "Cars In Transit",
    entity: "inventory",
    criteria: "carsInTransit",
    displayType: "count",
    icon: "Truck",
    color: "#000000",
    navigationUrl: "/dashboard/inventory?tab=in_transit",
  },
  {
    id: "6",
    name: "Live Inventory",
    criteria: "liveInventory",
    entity: "inventory",
    displayType: "count",
    icon: "Play",
    color: "#000000",
    navigationUrl: "/dashboard",
  },
  {
    id: "7",
    name: "Front Line Ready",
    entity: "inventory",
    criteria: "frontLineReady",
    displayType: "count",
    icon: "Key",
    color: "#000000",
    navigationUrl: "/dashboard",
  },
  {
    id: "2",
    name: "Cars In Prep",
    entity: "inventory",
    criteria: "carsInPrep",
    displayType: "count",
    icon: "ArrowPathLoop",
    color: "#000000",
    navigationUrl: "/dashboard",
  },
  {
    id: "3",
    name: "Cars In Prep",
    entity: "inventory",
    criteria: "carsInPrep",
    displayType: "pie",
    icon: "ChartPie",
    color: "#000000",
    navigationUrl: "/dashboard",
  },
  {
    id: "9",
    name: "In Staging",
    entity: "inventory",
    criteria: "carsInStaging",
    displayType: "count",
    icon: "VideoCamera",
    color: "#000000",
    navigationUrl: "/dashboard/inventory?tab=staging",
  },
  {
    id: "10",
    name: "Pending Check In",
    entity: "inventory",
    criteria: "pendingCheckIn",
    displayType: "count",
    icon: "ArrowLeftRectangle",
    color: "#000000",
    navigationUrl: "/dashboard/inventory?tab=check_in",
  },
  {
    id: "11",
    name: "Pending Check Out",
    entity: "inventory",
    criteria: "pendingCheckOut",
    displayType: "count",
    icon: "ArrowRightRectangle",
    color: "#000000",
    navigationUrl: "/dashboard/inventory?tab=check_out",
  },
  {
    id: "12",
    name: "Sales this Week",
    entity: "inventory",
    criteria: "salesThisWeek",
    displayType: "line",
    icon: "ArrowTrendingUp",
    color: "#000000",
    navigationUrl: "/dashboard/reports/vehicle-sales",
  },
  {
    id: "13",
    name: "Open Vehicle Issues",
    entity: "inventory",
    criteria: "openVehicleIssues",
    displayType: "count",
    icon: "Ticket",
    color: "#000000",
    navigationUrl: "/dashboard/issues",
  },
  {
    id: "14",
    name: "Vehicle Issues in Progress",
    entity: "inventory",
    criteria: "vehicleIssuesInProgress",
    displayType: "count",
    icon: "Ticket",
    color: "#000000",
    navigationUrl: "/dashboard/issues?status=in_progress",
  },
];

const financeWidgetsList = [
  {
    id: "50",
    name: "Late Invoices Total",
    entity: "finance",
    criteria: "lateInvoicesTotal",
    displayType: "count",
    icon: "ExclamationTriangle",
    color: "#000000",
    navigationUrl: "/dashboard/accounts-receivable?tab=invoices_by_customer",
  },
  {
    id: "51",
    name: "Late Invoices",
    entity: "finance",
    criteria: "lateInvoices",
    displayType: "count",
    icon: "ExclamationTriangle",
    color: "#000000",
    navigationUrl: "/dashboard/accounts-receivable?tab=invoices_by_customer",
  },
  {
    id: "52",
    name: "Unpaid Invoices",
    entity: "finance",
    criteria: "unpaidInvoices",
    displayType: "count",
    icon: "EnvelopeOpen",
    color: "#000000",
    navigationUrl: "/dashboard",
  },
  {
    id: "53",
    name: "Unpaid Invoices $",
    entity: "finance",
    criteria: "unpaidInvoices",
    displayType: "count",
    icon: "EnvelopeOpen",
    color: "#000000",
    navigationUrl: "/dashboard",
  },
  {
    id: "54",
    name: "Paid Invoices",
    entity: "finance",
    criteria: "paidInvoices",
    displayType: "count",
    icon: "Envelope",
    color: "#000000",
    navigationUrl: "/dashboard",
  },
  {
    id: "55",
    name: "Invoices Due",
    entity: "finance",
    criteria: "invoicesDue",
    displayType: "count",
    icon: "BarsArrowUp",
    color: "#000000",
    navigationUrl: "/dashboard",
  },

  {
    id: "56",
    name: "Invoices Owed",
    entity: "finance",
    criteria: "invoicesOwed",
    displayType: "count",
    icon: "BarsArrowDown",
    color: "#000000",
    navigationUrl: "/dashboard",
  },
  {
    id: "57",
    name: "Total Owed",
    entity: "finance",
    criteria: "invoicesOwed",
    displayType: "total",
    icon: "Banknotes",
    color: "#000000",
    navigationUrl: "/dashboard",
  },
  {
    id: "58",
    name: "Pay Reports Owed",
    entity: "finance",
    criteria: "payReportsOwed",
    displayType: "count",
    icon: "DocumentArrowUp",
    color: "#000000",
    navigationUrl: "/dashboard",
  },
];

const taskWidgetsList = [
  {
    id: "100",
    name: "Tasks Assigned",
    entity: "tasks",
    criteria: "tasksAssigned",
    displayType: "count",
    icon: "UserPlus",
    color: "#000000",
    navigationUrl: "/dashboard/tasks/byTasks",
  },
  {
    id: "101",
    name: "Tasks Due",
    entity: "tasks",
    criteria: "tasksDue",
    displayType: "count",
    icon: "Clock",
    color: "#000000",
    navigationUrl: "/dashboard/tasks/byTasks",
  },
  {
    id: "102",
    name: "Late Tasks",
    entity: "tasks",
    criteria: "lateTasks",
    displayType: "count",
    icon: "ExclamationCircle",
    color: "#000000",
    navigationUrl: "/dashboard/tasks/byTasks",
  },
  {
    id: "103",
    name: "Blocked Tasks",
    entity: "tasks",
    criteria: "blockedTasks",
    displayType: "count",
    icon: "Ban",
    color: "#000000",
    navigationUrl: "/dashboard/tasks/byTasks",
  },
  {
    id: "104",
    name: "Unassigned Tasks",
    entity: "tasks",
    criteria: "unassignedTasks",
    displayType: "count",
    icon: "UserGroup",
    color: "#000000",
    navigationUrl: "/dashboard/tasks/byTasks",
  },
  {
    id: "105",
    name: "Upcoming Jobs",
    entity: "tasks",
    criteria: "upcomingJobs",
    displayType: "count",
    icon: "Briefcase",
    color: "#000000",
    navigationUrl: "/dashboard/jobs/list",
  },
];

const chartDisplayTypes = ["graph", "pie", "bar", "line"];

export {
  inventoryWidgetsList,
  financeWidgetsList,
  taskWidgetsList,
  chartDisplayTypes,
};
